<template>
  <section class="content-task-register-contents">
    <Breadcrumb :links="links" :data="{name: 'Tarefa', id: currentTask.id}"/>
    <form class="content-task-register-contents-form">
      <div class="row">
        <div class="col-12">
          <CardContentsTask/>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import CardContentsTask from '@/views/Tasks/components/CardContentsTask';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: '',
          routerName: 'Tasks'
        },
        {
          name: 'Menu',
          routerName: 'MenuTasks'
        },
        {
          name: 'Cadastrar Conteúdo',
          routerName: 'RegisterContents'
        },
      ],
    }
  },
  computed: {
    ...mapGetters('Tasks', ['currentTask'])
  },
  components: {
    Breadcrumb,
    CardContentsTask
  },
  async mounted() {
    let task = await this.currentTask;
    if (task && Object.keys(task).length > 0){
      this.links[0].name = task.name;
    }
  }
}
</script>

<style lang="scss" scoped>
.content-task-register-contents {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
  label {
    width: 100%;
    font-size: 10px;
    font-family: 'Font Light';
    color: var(--black);
    text-align: left;
    padding: 0px 20px;
    margin-bottom: 0;
    span {
      color: var(--red-light);
    }
  }
}
.btn-green {
  margin-top: 250px;
  @media (max-width: 991px){
    margin-top: 125px;
  }
}
</style>
